import React, { useEffect, useState, Fragment } from 'react';
import Layout from 'components/sales/layout/layout';
import TableSection from 'components/sales/tableSection/tableSection';
import { ArrowRight, Filter, tick } from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import ListFilters from 'components/sales/ListFilters/ListFilters';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import ModalPop from 'components/sales/modal/modal';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import Images from 'assets/images/imageData';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import DivLayout from 'components/sales/divLayout/divLayout';

const RaisedRequestsList = ({
    requestDetails,
    getRenewalRequestDetails,
    match
}) => {
  

  const [listData, setListData] = useState();
  const [activePostSales, setActivePostSales] = useState();
  const [teamId, setTeamId] = useState();
  const [departmentId, setDepartmentId] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [filterData, setFilterData] = useState(null);
  const [showFilter, setShowFilter] = useState(false);
  const [isStatusSuccess, setIsStatusSuccess] = useState(false);
  const [isRoleId, setIsRoleId] = useState(null);
  const [actionData, setActionData] = useState();
  const [isModal, setIsModal] = useState(false);
  const [isSuccessModel, setIsSuccessModel] = useState(false);
  const [modificationModal, setModificationModal] = useState(false);
  const [isRejectedModal, setIsRejectedModal] = useState(false);
  const [isApprovedModal, setIsApprovedModal] = useState(false);

  useEffect(() => {

    if (getRenewalRequestDetails !== null) {
      (async () => {
        setIsLoading(true);
        await getRenewalRequestDetails(match.params.id,match.params.site_id,true);
        setIsLoading(false);
      })();
    }
  }, [getRenewalRequestDetails]);
  
  return (
    <Layout
      title={localization.approvedSalesLeadListing}
      isLoading={isLoading}
      isGoback
    >
      {requestDetails && requestDetails.length > 0 && requestDetails.map((request, requestIndex) => (
        <div key={requestIndex} className="panel-card card-details" width="100%">
          <div className="panel-heading">{'Request Details ' + (requestDetails.length - requestIndex)}</div>
          <div className="panel-body">
            <div className="details-listing detail_alignment">
              {/* General Request Details */}
              <DivLayout heading={'Site Number'} data={request?.site_no || 'N/A'} />
              {/* <DivLayout heading={'Live Date'} data={request?.live_date || 'N/A'} />
              <DivLayout heading={'Expiry Date'} data={request?.expiry_date || 'N/A'} /> */}
              <DivLayout heading={'Contract Length'} data={request?.contract_length ? `${request?.contract_length} months` : 'N/A'} />
              <DivLayout heading={'Status'} data={request?.status || 'N/A'} />
              <DivLayout heading={'Client Name'} data={request?.client_name || 'N/A'} />
              <DivLayout heading={'Payment Term'} data={request?.payment_term || 'N/A'} />
              <DivLayout heading={'Contract Type'} data={(request?.contract_type==16)?'AMC': (request?.contract_type==7)?'Rental':'N/A'} />
              <DivLayout heading={'Requested By'} data={request?.created_by_user_name || 'N/A'} />
              <DivLayout heading={'Requested At'} data={request?.created_at || 'N/A'} />
              {request?.remarks && <DivLayout
                        heading={'Rejection Remarks'}
                        data={request?.remarks || 'N/A'}
                    />}
            </div>

            <div className="panel-heading">{'Gate Details'}</div>
            <div className="details-listing detail_alignment">
              {request?.gate_data && request?.gate_data.length > 0 ? (
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>Gate Name</th>
                      <th>AMC Type</th>
                      <th>Price(Rs.)</th>
                      <th>Software Price(Rs.)</th>
                      <th>Total Gate Price(Rs.)</th>
                    </tr>
                  </thead>
                  <tbody>
                    {request?.gate_data.map((gate, gateIndex) => (
                      <tr key={gateIndex}>
                        <td>{gate?.name || 'N/A'}</td>
                        <td>{(gate?.amc=='comp')?'Comprehensive':(gate?.amc=='nonComp')?'Non-Comprehensive':'N/A'}</td>
                        <td>{gate?.hardware_price || 'N/A'}</td>
                        <td>{gate?.software_price || 'N/A'}</td>
                        <td>{(Number(gate?.hardware_price)+Number(gate?.software_price)) || 'N/A'}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <DivLayout heading={'Gate Data'} data={'No Gate Data'} />
              )}
              <div className="row" style={{ marginTop: '15px' }}>
                <div className="col-md-6" style={{ display: 'flex',justifySelf: 'end',marginRight: 'unset'}}>
                    <DivLayout mkClass="additionalChargesRemarkCss details-list" heading={'Additional Cost Remarks'} data={request?.additional_cost_remarks || 'N/A'} />
                </div>
                <div className="col-md-6" style={{display: 'flex',justifyContent: 'flex-end' ,marginLeft:'-25px'}}>
                    <DivLayout mkClass="additionalChargesRemarkCss details-list" heading={'Additional Cost (Rs.)'} data={request?.additional_cost || 'N/A'} />
                </div>
            </div>

            {/* Total Cost centered below */}
            <div
                className="row"
                style={{
                    marginTop: '15px',
                    display: 'flex',
                    justifyContent: 'center',
                    textAlign: 'center',
                    fontSize: 'medium'
                }}
            >
                <div
                    className="col-12"
                    style={{
                        maxWidth: '300px', // Restricting the width
                        textAlign: 'center', // Ensuring text is centered within
                        margin: '0 auto' // Centering within the row
                    }}
                >
                    <DivLayout
                        mkClass="totalCostCss details-list"
                        heading={'Total Cost (Rs.)'}
                        data={request?.total_cost || 'N/A'}
                    />
                </div>
            </div>

            </div>
            {/* <div className="panel-heading">{'Gate Details'}</div>
            <div className="details-listing detail_alignment"> */}
            {/* </div> */}
            {/* Increment Details Section */}
            <div className="panel-heading">{'Increment Details'}</div>
            <div className="panel-body">
              <div className="details-listing detail_alignment">
                <DivLayout
                  heading="Increment Type"
                  data={request?.increament_data?.inc?.increament_type === 'nonUniform' ? 'Non-Uniform' : request?.increament_data?.inc?.increament_type}
                />
                {request?.increament_data?.inc?.increament_type === 'nonUniform' ? (
                  request?.increament_data?.input?.map((item, index) => (
                    <DivLayout key={index} heading={`Subscription Amount ${index + 1}`} data={item?.subscription_amounts} />
                  ))
                ) : (
                  <div>
                    <DivLayout heading="Duration" data={request?.increament_data?.inc?.duration} />
                    <DivLayout heading="Increment Amount " data={request?.increament_data?.inc?.increament_amount} />
                  </div>
                )}
              </div>
            </div>
          </div>
          {/* <div className="panel-heading">{'Client Status'}</div>
            <div className="panel-body">
              <div className="details-listing detail_alignment">
                     <DivLayout heading="Client Alignment " data={request?.client_status} />
                    <DivLayout heading="Alignment Reason" data={request?.client_status_reason} />
                    <DivLayout heading="Other Remarks" data={request?.client_status_reason_remarks} />
              </div>
            </div> */}
        </div>
      ))}
    </Layout>
  );
};

export default RaisedRequestsList;
